import React from 'react'

import { CheckCircle } from '@phosphor-icons/react'
import { Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { GROW_SECTION_CHECKLIST_ITEMS } from './constants'
import { Container, Item } from './styles'

function GrowSectionCheckboxList() {
  const { isMobile } = useResponsiveLayout()

  return (
    <Container
      gap={[6, 6, 6, 7]}
      gridTemplateColumns={[
        '1fr',
        '1fr',
        'repeat(2, 1fr)',
        'repeat(2, 1fr)',
        'repeat(3, 1fr)',
      ]}
    >
      {GROW_SECTION_CHECKLIST_ITEMS.map(item => (
        <Item
          flexDirection={['column', 'column', 'column', 'row']}
          gap={[3, 3, 3, 2]}
          key={item.id}
        >
          <CheckCircle size={20} weight="fill" />

          <Text body center={isMobile} medium screen18>
            {item.caption}
          </Text>
        </Item>
      ))}
    </Container>
  )
}

export default GrowSectionCheckboxList
